import React, { useState, useEffect, useRef } from 'react';
import "../AddClients/tableStyle.css"
import { getclientslist, getAllDoByClient, getLifterPaymentByDoId } from '../../Services/Services';
import { Select, Form, Button } from 'antd';
import LifterPayFrm from './LifterPayFrm';
import Header from '../Header-Footer/Header';
import { useReactToPrint } from 'react-to-print';
import { FaFilePdf, FaFileExcel , FaPrint} from 'react-icons/fa';
import Footer from '../Header-Footer/Footer';
import * as XLSX from 'xlsx'; // Import xlsx library
import { Link } from 'react-router-dom';
export default function LifterPayView() {
  const [lifteruserList, setlifteruserList] = useState([]);
  const [payList, setPayList] = useState([])
  const [doList, setdoList] = useState([])
  useEffect(() => {
    
    if(localStorage.getItem('user_type')!=='Lifter'){
      GetLifterlist()
    }else{
      Get_Do_Details(localStorage.getItem('user_id'))
    }
  }, [])
  const GetLifterlist = async () => {
    const response = await getclientslist();
    if (response) {
      const filterLifter = response.lifter_user_list.filter(o =>o.com_name === localStorage.getItem('com_name'))
      setlifteruserList(filterLifter)
    }
  }

  const Get_Do_Details = async (id) => {
    const response = await getAllDoByClient({'com_name':localStorage.getItem('com_name'),'lifter_id':id})
    if (response) {
      setdoList(response);
    }
  };

  const Get_Pay_Details = async (id) => {
    const response = await getLifterPaymentByDoId({'com_name':localStorage.getItem('com_name'),'do_id':id})
    if (response) {

      setPayList(response);
    }
  };
  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });
  const handleExportToExcel = () => {
    const workbook = XLSX.utils.book_new();
    const wsData = payList.map((e, index) => [
      index + 1,
      e.lifter_name,
      e.do_no,
      e.pay_amount,
      e.date,
    
    ]);

    const worksheet = XLSX.utils.aoa_to_sheet([
      ['Sr. No', 'Lifter Name','Do No','Pay Amount','Date'],
      ...wsData,
    ]);
    XLSX.utils.book_append_sheet(workbook, worksheet, 'DeliveryOrder');

    // Save the workbook as an Excel file
    XLSX.writeFile(workbook, 'Lifter Pay .xlsx');
  };
  const formateDate =(date)=>{
    const [year, month, day] = date.split('-');
    const formattedDate = `${day}-${month}-${year}`;
    return formattedDate
  }
  
  return (
    <div style={{ height:'90vh' }}>
      <Header heading="LIFTER PAYMENT VIEW" />
      <Form
        layout="vertical"
      >
       {localStorage.getItem('user_type')!=='Lifter'? 
       <div className=" grid grid-cols-1 sm:grid sm:grid-cols-3 sm:gap-2 m-auto px-5 sm:w-[70%]  md:w-[100%] ">
          <Form.Item
            name="lifter_id"
            label={<b>Select Lifter Name</b>}
            style={{ padding: "2px", margin: "2px" }}
          >
            <Select
              showSearch
              placeholder="Search to Select"
              optionFilterProp="children"
              onChange={Get_Do_Details}
            > {lifteruserList.map((e) => (
              <Select.Option value={e.id}>
                {e.name}
              </Select.Option>))}
            </Select>
          </Form.Item>

          <Form.Item
            name="do_id"
            label={<b>Select DO No</b>}
            style={{ padding: "2px", margin: "2px" }}
          >
            <Select
              showSearch
              placeholder="Search to Select"
              optionFilterProp="children"
              onChange={Get_Pay_Details}
            >
              {doList.map((do_i) => (
                <Select.Option value={do_i.id}>
                  {do_i.do_no}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item>
            <br></br>
            <LifterPayFrm />
            <Button onClick={handlePrint} style={{ backgroundColor: 'black', color: 'white',bottom:'-5px' }}>
              <FaPrint/>
            </Button>
            <Button onClick={handleExportToExcel} style={{ backgroundColor: 'green', color: 'white', marginLeft: '10px',bottom:'-5px' }}><FaFileExcel/></Button>

          </Form.Item>
        </div>
        :
        <div className=" grid grid-cols-1 sm:grid sm:grid-cols-2 sm:gap-2 m-auto px-5 sm:w-[70%]  md:w-[100%] ">
        <Form.Item
          name="do_id"
          rules={[
            {
              required: true,
              message: "Please select the DO ID!",
            },
          ]}
          label={<b>Select DO No</b>}
          style={{ padding: "2px", margin: "2px" }}
        >
          <Select
            showSearch
            placeholder="Search to Select"
            optionFilterProp="children"
            onChange={Get_Pay_Details}
          >
            {doList.map((do_i) => (
              <Select.Option value={do_i.id}>
                {do_i.do_no}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item label=' '>

          <Button onClick={handlePrint} style={{ backgroundColor: 'black', color: 'white' }}>
            PDF
          </Button>
          <Button onClick={handleExportToExcel} style={{ backgroundColor: 'green', color: 'white', marginLeft: '10px' }}><FaFileExcel/></Button>

        </Form.Item>
      </div>
}


      </Form>
      <div className="table-container" ref={componentRef}>
        <table id="my-table" className="w-full relative">
          <thead className="bg-[#151B54] w-full text-white">
            <tr>
              <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-2 px-1 lg:p-1 sm:text-base">Sr. No</th>
              <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-2 px-1 lg:p-1 sm:text-base">Lifter Name</th>
              <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">Do No</th>
              <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">Amount</th>
              <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-2 px-1 lg:p-1 sm:text-base">Date</th>
            </tr>
          </thead>
          <tbody>

            {payList.map((e, index) => (

              <tr key={e.index} style={{ backgroundColor: e.rem_qty === 0 ? '#b8ebb8' : '' }}>
                <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">{index + 1}</td>
                <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">{e.lifter_name}</td>
                <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                  <Link to={`/do-view/${e.do_id}`}><u style={{ fontWeight: '600', color: 'blue' }}>
                    {e.do_no}
                  </u></Link>
                </td>
                <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">{e.pay_amount}</td>
                <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">{formateDate(e.date)}</td>

              </tr>
            ))}
            <tr style={{ backgroundColor: '#e9e9e9' }}>
              <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base" colSpan={3}><b>Total</b></td>
              <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                <b>{payList.reduce(
                  (accumulator, currentValue) =>
                    accumulator + (+currentValue.pay_amount),
                  0
                ).toFixed(2)}</b></td>


              <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base"></td>
            </tr>
          </tbody>
        </table>
      </div>
      {/* <Footer/> */}
    </div>
  )
}
